import React, { useEffect, useState } from 'react';
import { isBrowser } from 'react-device-detect';

import Utils from '@/utils/util';
import { AppointmentData, Business, LocationDropdown } from '../types';

import GlobeIcon from '@/assets/img/user-icon.svg';
import DateIconGrey from '@/assets/img/date-icon-gray.svg';
import LocationIcon from '@/assets/img/v2/location.svg';
import MeetingTimeIcon from '@/assets/img/time-icon.svg';
import ServiceIcon from '@/assets/img/v2/service-icon.svg';
import UserIcon from '@/assets/img/user-icon.png';

import './BusinessMeetingDetails.scss';
import moment from 'moment';
import { DropDown } from '@/components/dropdown/DropDown';
import storage from '@/utils/storage';
import ConfirmationDialogV2 from '@/components/ConfirmationDialog/ConfirmationDialogV2';
import { useTranslation } from 'react-i18next';
export type AppointmentDetailsProps = {
  business?: Business;
  data?: AppointmentData;
  showExtraInfo?: boolean;
  onChange?: (data: AppointmentData) => void;
  isPaymentViaLink?: boolean;
};

export const AppointmentInfoPanel = ({
  data,
  business,
  showExtraInfo,
  onChange,
  isPaymentViaLink,
}: AppointmentDetailsProps) => {
  const [locations, setLocations] = useState<LocationDropdown[]>([]);
  const slotLabel = data?.slot?.label ? `(${data?.slot?.label})` : '';
  const [showBusinessDescription, setShowBusinessDescription] = useState<boolean>(true);
  const [selectedLocationId, setSelectedLocationId] = useState('');
  const [confirmLocationChange, setConfirmLocationChange] = useState(false);
  const { t } = useTranslation();
  const onBusinessInfoClick = () => {
    setShowBusinessDescription(!showBusinessDescription);
  };
  useEffect(() => {
    const locations: LocationDropdown[] = [];
    business?.locations.forEach((location: any) => {
      locations.push({
        label: location.address,
        value: location.id,
        additionalData: location.distance,
      });
    });
    setLocations(locations);
    // if(locations.length > 1) {
    //   onLocationChange(locations[0].value);
    // }
  }, []);

  const totalDaysBooked = data?.cost?.days;
  const onLocationChange = (value: string) => {
    if (data?.selectedServiceType) {
      setSelectedLocationId(value);
      setConfirmLocationChange(true);
    } else {
      const filteredLocation = business?.locations.find((loc: any) => loc.id === value);
      onChange && onChange({ ...data, selectedLocation: filteredLocation });
      business && storage.setKey(`loc_id_${business.type === "business" ? business.slug : filteredLocation.slug}`, value ? value : '');
    }
  };
  const approveLocationChange = (locationId: string | undefined) => {
    const filteredLocation = business?.locations.find((loc: any) => loc.id === locationId);
    onChange &&
      onChange({
        selectedServiceType: undefined,
        parentProfile: data?.parentProfile,
        creditCard: data?.creditCard,
        business: data?.business,
        selectedLocation: filteredLocation,
      });
    business && storage.setKey(`loc_id_${business.type === "business" ? business.slug : filteredLocation.slug}`, locationId ? locationId : '');
    setConfirmLocationChange(false);
  };
  const selectedLocation = data?.selectedLocation;
  return (
    <div className="meeting-details">
      <span
        className={`business-info ${showBusinessDescription ? '' : 'hide'}`}
      >
        {/* <img src={DownArrow} className="down-arrow" /> */}

        {business && business?.businessImageUrl && (
          <img
            className="user-icon"
            src={business?.businessImageUrl ? business?.businessImageUrl : UserIcon}
            alt="user icon"
          />
        )}
        {isPaymentViaLink ?<p className="host-name">{business?.name}</p> :  data?.selectedLocation && data?.selectedLocation.name && <p className="host-name">{data?.selectedLocation.name}</p>}
        {locations.length > 1 && <p className='dd-label'>Select/Change location below:</p>}
        {!isPaymentViaLink && locations.length > 1 &&  <span className="dd-container">
          <img className="location-icon" src={LocationIcon} />
          <DropDown
            placeholder="Select Location"
            selectedValue={data?.selectedLocation?.id}
            data={locations}
            additionalLabel="Distance"
            onSelect={onLocationChange}
            onDismiss={() => {}}
            enableSearch={false}
            />
        </span>}
        {!isPaymentViaLink && locations.length === 1 &&  <span className="location-address">
          {/* <img className="location-icon" src={LocationIcon} /> */}
          <p className='desc m-0'>{data?.selectedLocation?.address}</p>
        </span>}
       {isPaymentViaLink ?  <p className={`desc`}>
          {business?.description
            ? business?.description
            : `Transform your pet's pampering experience at our grooming and pet care store, where
              expertise meets love.`}
        </p>:  <p className={`desc`}>
          {data?.selectedLocation?.description
            ? data?.selectedLocation?.description
            : `Transform your pet's pampering experience at our grooming and pet care store, where
              expertise meets love.`}
        </p>}
      </span>
      {showExtraInfo ? (
        <div className={`extra ${showBusinessDescription ? '' : 'hide'}`}>
          {(data?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING ||
            data?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
            data?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE) &&
            data?.slot && (
              <>
                <span>
                  <img src={DateIconGrey} />{' '}
                  {Utils.getOnlyDate(
                    data?.slot.start,
                    selectedLocation?.timezone,
                    'dddd, MMMM DD, YYYY'
                  )}{' '}
                  <br />{' '}
                  {Utils.getOnlyDate(data?.slot.start, selectedLocation?.timezone, 'hh:mm A')} -{' '}
                  {Utils.getOnlyDate(data?.slot.end, selectedLocation?.timezone, 'hh:mm A')}{' '}
                  {Utils.getTzAbbr(selectedLocation?.timezone)}
                </span>
              </>
            )}
          {(data?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
            data?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) &&
            data?.startDate &&
            data?.endDate && (
              <span>
                <img src={DateIconGrey} />{' '}
                {Utils.getOnlyDate(
                  data?.startDate,
                  isPaymentViaLink ? data?.selectedLocation?.timezone : undefined,
                  'MMM DD, YYYY'
                )}
                {' - '}
                {Utils.getOnlyDate(
                  data?.endDate,
                  isPaymentViaLink ? data?.selectedLocation?.timezone : undefined,
                  'MMM DD, YYYY'
                )}
              </span>
            )}

          {data?.service && (
            <>
              <span>
                <img src={ServiceIcon} /> {data?.service?.name}
              </span>
              <span>
                <img src={MeetingTimeIcon} />{' '}
                {Utils.minutesToDhm(data?.duration ? data?.duration : 0)}
              </span>
            </>
          )}
          {(data?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
            data?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
            data?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE ||
            data?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) && (
            <>
              <span>
                <img src={ServiceIcon} />{' '}
                {data?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
                data?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE
                  ? t('Daycare service')
                  : t('Boarding service')}
              </span>
              {(data?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
                data?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) &&
                !isPaymentViaLink &&
                totalDaysBooked && (
                  <span>
                    <img src={MeetingTimeIcon} /> {totalDaysBooked}
                    {totalDaysBooked > 1 ? ' Days' : ' Day'}
                  </span>
                )}
              {(data?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
                data?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) &&
                isPaymentViaLink && (
                  <span>
                    <img src={MeetingTimeIcon} />{' '}
                    {Utils.totalDaysBooked(data, undefined, business?.timezone)}
                  </span>
                )}
              {(data?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE ||
                data?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE) &&
                data?.duration && (
                  <span>
                    <img src={MeetingTimeIcon} />{' '}
                    {Utils.minutesToDhm(data?.duration ? data?.duration : 0)}
                  </span>
                )}
            </>
          )}
          {/* {data?.room && (
            <>
              <span>
                <img src={ServiceIcon} /> {data?.room?.name}
              </span>
              <span>
                <img src={MeetingTimeIcon} />{' '}
                {Utils.minutesToDhm(data?.duration ? data?.duration : 0)}
              </span>
            </>
          )} */}
          {data?.provider && (
            <span className="service-provider">
              <img
                src={data?.provider?.avatarUrl ? data?.provider?.avatarUrl : UserIcon}
                alt="avatar url"
              />
              <span className="sp-name">{data?.provider?.name}</span> (Service provider)
            </span>
          )}

          {isBrowser
            ? selectedLocation?.timezone && (
                <span className="tz">
                  <img src={GlobeIcon} />
                  <span>{Utils.getDetailedTz(selectedLocation?.timezone)}</span>
                </span>
              )
            : selectedLocation?.timezone && (
                <span>
                  <img src={GlobeIcon} />
                  {Utils.getDetailedTz(selectedLocation?.timezone)}
                  <span className="light"> {slotLabel}</span>
                </span>
              )}
        </div>
      ) : (
        selectedLocation?.timezone && (
          <div className={`extra ${showBusinessDescription ? '' : 'hide'}`}>
            <span className="tz spacer">
              <img src={GlobeIcon} />
              {Utils.getTzAbbr(selectedLocation?.timezone)}
            </span>
          </div>
        )
      )}
      <ConfirmationDialogV2
        title={'Change Location?'}
        description={'Do you really want to change the location?'}
        yesButtonLabel="Yes, Confirm"
        noButtonLabel="No, Not Now"
        onCancel={() => setConfirmLocationChange(false)}
        onConfirm={() => approveLocationChange(selectedLocationId)}
        open={confirmLocationChange}
      >
        {
          <div className="remove-member-confirmation refund-details">
            <div className="refund-status">Changing Location will reset all the data</div>
          </div>
        }
      </ConfirmationDialogV2>
    </div>
  );
};
